import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IAuthForm } from "../../../model/afidium-connect.model";
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';

class Wording {
  public readonly labelUsername: string = Yii.t('wui-app-js', 'Votre identifiant');
  public readonly labelPassword: string = Yii.t('wui-app-js', 'Votre mot de passe');
  public readonly errorUsername: string = Yii.t('wui-app-js', 'Veuillez saisir un identifiant');
  public readonly errorPassword: string = Yii.t('wui-app-js', 'Veuillez saisir un mot de passe');
  public readonly submit: string = Yii.t('wui-app-js', 'Se connecter');
}

@Component({
  selector: 'auth-form',
  templateUrl: 'auth-form.component.html',
  styleUrls: ['auth-form.component.scss']
})
export class AuthFormComponent implements OnInit {
  @Output()
  public submitAuthFormEvent: EventEmitter<IAuthForm> = new EventEmitter<IAuthForm>();
  public readonly wording: Wording = new Wording();
  public authForm: FormGroup;
  public username: FormControl;
  public password: FormControl;
  public isSubmit: boolean = false;
  public fields: IFieldSpecs[];
  
  constructor(private fb: FormBuilder) { }

  public ngOnInit(): void {
    this.initAuthForm();
    this.initUsername();
    this.initPassword();
    this.initFields()
  }

  public submit(): void {
    this.isSubmit = true;
    if (this.authForm.valid) {
      this.isSubmit = false;
      this.submitAuthFormEvent.emit(this.makeIAuthForm());
    }
  }

  private initAuthForm(): void {
    this.authForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  private initUsername(): void {
    this.username = this.authForm.get('username') as FormControl;
  }

  private initPassword(): void {
    this.password = this.authForm.get('password') as FormControl;
  }

  private initFields(): void {
    this.fields = [
      {
        formGroup: this.authForm,
        formControlName: 'username',
        label: this.wording.labelUsername,
        errorMessage: this.wording.errorUsername,
        type: 'text'
      },
      {
        formGroup: this.authForm,
        formControlName: 'password',
        label: this.wording.labelPassword,
        errorMessage: this.wording.errorPassword,
        type: 'password'
      }
    ];
  }

  private makeIAuthForm(): IAuthForm {
    return {
      login: {
        uid: this.username.value,
        pwd: this.password.value
      }
    };
  }
}
